import React from 'react';
import { Page, Document, Text, StyleSheet, View } from '@react-pdf/renderer';
import { findObjIntoArrayByProp, displayDate, formatMoney, displayDateTime, formatPhoneNumber } from '@iso/lib/helpers/utility';

const styles = StyleSheet.create({
    page: {
        fontSize: 12,
        paddingTop: 10,
        lineHeight: 1.5,
        paddingLeft: 10,
        paddingRight: 10,
        paddingBottom: 10,
        fontFamily: 'Helvetica',
        flexDirection: 'column'
    },
    title: {
        fontSize:15,
        color:'#4f4a4a',
        fontFamily: 'Helvetica-Bold',
    },
    title2: {
        fontSize:13,
        textTransform:'uppercase',
        // fontFamily: 'Helvetica-Bold'
    },
    box:{
        width: '100%',
        padding:'5px',
        color:'#4f4a4a',
        textAlign:'left'
    },
});

const Receipt = ({ data }) => {
    const showPaymentForm = (f) => {
        try {
            let pi = findObjIntoArrayByProp(data.paymentForms, '_id', f);
            if(pi !== -1)
                return data.paymentForms[pi].name;
        } catch (error) {}
    }

    return (
        <Document>
            <Page size="A4" orientation='portrait' style={styles.page} wrap={true}>
                <View style={{ flexDirection: 'column', border: '1px solid #CCC', borderRadius:'2px', padding:'3px' }}>
                    <View style={{ flexDirection: 'row' }}>
                        <View style={{...styles.box, width: '40%' }}>
                            <Text style={styles.title2}>{data.empresa.nameSocial}</Text>
                            <Text style={styles.title2}>{data.empresa.email}</Text>
                            <Text style={styles.title2}>{formatPhoneNumber(data.empresa.fone)}</Text>
                        </View>
                        <View style={{...styles.box, width: '60%' }}>
                            <Text style={{...styles.title, textAlign:'right'}}>Comprovante de pagamento gerado em:</Text>
                            <Text style={{textAlign:'right'}}>{displayDateTime()}</Text>
                        </View>
                    </View>
                    <View style={{ ...styles.box, flexDirection:'row', alignItems:'center', marginTop:'10px', borderTop: '1px solid #CCC' }}>
                        <Text style={{...styles.title, width:'40%', textAlign:'right', paddingRight: '10px'}}>Pagamento efetuado por: </Text>
                        <Text style={{width:'60%'}}>{data.bill.clientName}</Text>
                    </View>
                    <View style={{ ...styles.box, flexDirection:'row', alignItems:'center', marginTop:'0px', borderTop: '1px solid #CCC'}}>
                        <Text style={{...styles.title, width:'40%', textAlign:'right', paddingRight: '10px'}}>Forma de pagamento: </Text>
                        <Text style={{width:'60%'}}>{showPaymentForm(data.bill.paymentForm)}</Text>
                    </View>
                    <View style={{ ...styles.box, flexDirection:'row', alignItems:'center'}}>
                        <Text style={{...styles.title, width:'40%', textAlign:'right', paddingRight: '10px'}}>Valor pago: </Text>
                        <Text style={{width:'60%'}}>R$ { formatMoney(data.bill.value) }</Text>
                    </View>
                    {
                        data.bill?.dueDate && (
                            <View style={{ ...styles.box, flexDirection:'row', alignItems:'center'}}>
                                <Text style={{...styles.title, width:'40%', textAlign:'right', paddingRight: '10px'}}>Data do vencimento: </Text>
                                <Text style={{width:'60%'}}>{ data.bill.dueDate }</Text>
                            </View>
                        )
                    }
                    <View style={{ ...styles.box, flexDirection:'row', alignItems:'center'}}>
                        <Text style={{...styles.title, width:'40%', textAlign:'right', paddingRight: '10px'}}> Data do pagamento: </Text>
                        <Text style={{width:'60%'}}>{ displayDate(data.bill.paymentDate) }</Text>
                    </View>
                </View>
            </Page>
        </Document>
    );
};

export default Receipt